export const arrayDistinct = (items: any[]) => Array.from(new Set(items))

export const arrayMapWhere = <T>(items: T[], predicate: (x: T) => boolean, map: (x: T) => T) =>
    items.map((x) => (predicate(x) ? map(x) : x))
